import { type Common } from './common.js';
import type * as ProviderTeam from './models/providerTeam.js';

export class API {
  common: Common;
  readonly baseEndpoint = '/provider-teams';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(
    args: {
      providerUserId?: string;
      practiceId?: string;
    } = {}
  ): Promise<ProviderTeam.ProviderTeam[]> {
    const url = this.common.constructPath(this.baseEndpoint, args);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<ProviderTeam.ProviderTeam> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }

  async create(values: ProviderTeam.CreateValues): Promise<ProviderTeam.ProviderTeam> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }
}
